<template>
  <v-row
    class="pa-4 search-condition"
  >
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <v-row
        class="ma-0"
      >
        <v-col
          cols="3"
          sm="3"
          md="3"
        >
          <h4>相談日</h4>
        </v-col>
        <v-col
          cols="3"
          sm="3"
          md="3"
        >
          <h4>ステータス</h4>
        </v-col>
        <v-col
          cols="6"
          sm="6"
          md="6"
        >
          <h4>担当相談員氏名（部分一致）</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="3"
          sm="3"
          md="3"
          class="pt-0 pb-0"
        >
          <DateConditionInput
            :model-value="condition.date"
            :min-selectable-date="minSelectableDate"
            @update:model-value="$emit('update:date', $event)"
          />
        </v-col>
        <v-col
          cols="3"
          sm="3"
          md="3"
          class="pt-0 pb-0"
        >
          <StatusConditionSelect
            :model-value="condition.status"
            :items="statuses"
            @update:model-value="$emit('update:status', $event)"
          />
        </v-col>
        <v-col
          cols="6"
          sm="6"
          md="6"
          class="pt-0 pb-0"
        >
          <DoctorNameConditionInput
            :family-name="condition.doctorFamilyName"
            :first-name="condition.doctorFirstName"
            @update:family-name="$emit('update:doctor-family-name', $event)"
            @update:first-name="$emit('update:doctor-first-name', $event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="6"
          sm="6"
          md="6"
        >
          <SearchActionButtons
            :is-searching="isSearching"
            @search="$emit('search')"
            @reset="$emit('reset')"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {
  DateConditionInput,
  StatusConditionSelect,
  DoctorNameConditionInput,
  SearchActionButtons
} from "../../../features/daytime-advice-search";

export default {
  name: "DaytimeAdviceSearchFormPanel",
  components: {
    DateConditionInput,
    StatusConditionSelect,
    DoctorNameConditionInput,
    SearchActionButtons
  },
  props: {
    condition: {
      type: Object,
      required: true,
      validator(value) {
        const requiredKeys = ["date", "status", "doctorFamilyName", "doctorFirstName"];
        return value && requiredKeys.every((key) => Object.prototype.hasOwnProperty.call(value, key));
      }
    },
    statuses: {
      type: Array,
      required: true,
      validator(value) {
        return Array.isArray(value) && value.every((item) => (
          item && Object.prototype.hasOwnProperty.call(item, "key") && Object.prototype.hasOwnProperty.call(item, "value")
        ));
      }
    },
    isSearching: {
      type: Boolean,
      required: true
    },
    minSelectableDate: {
      type: Date,
      default: null
    }
  },
  emits: [
    "update:date",
    "update:status",
    "update:doctor-family-name",
    "update:doctor-first-name",
    "search",
    "reset"
  ]
};
</script>

<style lang="scss" scoped>
.search-condition {
  background-color: #fff;

  :deep(.dp__input) {
    line-height: 2.625rem;
  }
}
</style>
